import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit, OnDestroy {
  @Input() initSelected: {month: number, day: number};
  @Input() identifyCurrentDay = false;
  @Input() disablePast = false;
  @Input() multiSelect = true;
  @Input() insertingTime: Subject<any>;
  @Input() insertingMonth: Subject<any>;
  @Input() insertingSchedule: Subject<any>;
  @Input() clearCalendarSubject: Subject<any>;

  @Output() selectedDay = new EventEmitter<any>();

  numberOfDays;
  withInitSelected = false;
  schedule = {};
  currentElements = {};
  currentMonth;
  currentYear;
  currentDayInMs;
  subscribes = [];
  startDay;
  daysConfig = {};
  constructor() { }

  ngOnInit() {
    this.numberOfDays = new Array(35);
    this.currentMonth =  new Date().getMonth() + 1;
    this.currentYear =  new Date().getFullYear();
    this.currentDayInMs = new Date().setHours(0, 0, 0, 0);
    this.detectStartDay();
    if (this.initSelected) {
      // console.log(this.initSelected);
      // this.currentMonth = this.initSelected.month;
    }
    this.withInitSelected = !!this.initSelected;
    if (this.insertingTime) {
    this.subscribes.push(this.insertingTime.subscribe(
      (resp: {item: number, add: boolean}) => {
        if (this.currentElements[this.currentMonth] && resp && this.currentElements[this.currentMonth][resp.item]) {
          if (!resp.add) {
            this.currentElements[this.currentMonth][resp.item].classList.remove('active-border');
          } else {
            this.currentElements[this.currentMonth][resp.item].classList.add('active-border');
          }
        }
    })
    );
    }
    if (this.insertingSchedule) {
      this.subscribes.push(this.insertingSchedule.subscribe(
        (resp: any) => {
          // console.log(resp);
          if (resp) {
            this.schedule = resp;
            // console.log(resp);
            // console.log(this.initSelected);
            if (this.initSelected) {
              this.withInitSelected = true;
              const initMoment =  moment().month(this.initSelected.month - 1).date(this.initSelected.day);
              this.selectedDay.emit({
                day: this.initSelected.day,
                month: this.initSelected.month,
                cntr: false,
                schedules: this.checkDay(initMoment)});
            }
          }
        }
      ));
    }
    if (this.insertingMonth) {
      this.subscribes.push(this.insertingMonth.subscribe(
          (resp: any) => {
            // console.log(resp);
            if (resp && resp.month > 0 && resp.month < 13) {
              this.clearCalendar(true);
              this.currentMonth = resp.month;
              this.currentYear = resp.year;
              this.detectStartDay(resp.month, resp.year);
            }
          }
          )
      );
    }
    if (this.clearCalendarSubject) {
      this.subscribes.push(this.clearCalendarSubject.subscribe(
        (resp: any) => {
          // console.log(resp);
          this.clearCalendar();
        }
        )
      );
    }
  }

  ngOnDestroy() {
    this.unsubscribe();
  }

  onSelectDay(event, day) {
    event.preventDefault();
    event.stopPropagation();
    this.withInitSelected = false;
    const currentElement = event.target.closest('li');
    if (!currentElement.classList.contains('disabled')) {
      if (!this.currentElements[this.currentMonth]) {
        this.currentElements[this.currentMonth] = {};
      }
      this.currentElements[this.currentMonth][currentElement.innerText] = currentElement;
      const multiselectEnebled = (event.ctrlKey || event.metaKey) && this.multiSelect;
      // console.log(this.schedule);
      // console.log(moment().month(this.currentMonth).year(this.currentYear).dayOfYear(this.startDay + day));
      // console.log(this.checkDay(moment().month(this.currentMonth).year(this.currentYear).dayOfYear(this.startDay + day)));
      this.selectedDay.emit({
        day: currentElement.innerText,
        month: this.currentMonth,
        cntr: multiselectEnebled || event.metaKey === true,
        schedules: this.checkDay(moment().month(this.currentMonth).year(this.currentYear).dayOfYear(this.startDay + day)),
        fetchProgram: true});
      if (!multiselectEnebled) {
        this.clearCalendar(false);
      }
      currentElement.classList.add('selectedCalendarItem');
    }
  }
  isDayActive(day) {
    // console.log(day);
    const date = moment().month(this.currentMonth).year(this.currentYear).dayOfYear(this.startDay + day);
    // console.log(date);
    const days = this.checkDay(date);
    // console.log(days);
    let editable = false;
    days.map(item => {
      if (item.api === false) {
        editable = true;
      }
    });
    const res = {active: days.length > 0, editable: editable};
    let id = this.currentYear + '_' + this.currentMonth + '_' + day;
    // if (date.month() === 2 && date.date() === 20) {
    //   console.log(this.initSelected, this.withInitSelected && this.initSelected && this.initSelected.month && date.month()+1 === +this.initSelected.month && date.date() === +this.initSelected.day, date);
    // }

    if (this.withInitSelected && this.initSelected && this.initSelected.month && date.month()+1 === +this.initSelected.month && date.date() === +this.initSelected.day) {
      setTimeout(() => {
        // console.log(this.initSelected);
        if (this.initSelected && this.initSelected.month) {
          id = this.currentYear + '_' + this.initSelected.month + '_' + this.initSelected.day;
          const elem = document.getElementById(id);
          // console.log(this.initSelected);
          // console.log(id);
          // console.log(elem);
          if (elem) {
            // console.log(elem);
            // this.currentElements[this.currentMonth][this.initSelected.day] = elem;
            this.withInitSelected = false;
            // this.selectedDay.emit({day: date.date(), cntr: false, schedules: [], initDay: true});
            elem.classList.add('selectedCalendarItem');
          }
        }
      }, 50);
    }
    this.daysConfig[id] = res;
    // console.log(day);
    // console.log(this.currentMonth);
    // console.log(date);
    // console.log(res);
    return  res;
  }
  isDisabled(day) {
    const date = moment().month(this.currentMonth).year(this.currentYear).dayOfYear(this.startDay + day);
    return this.disablePast && date.isBefore(moment()) || date.month() + 1 !== this.currentMonth;
  }
  isCurrentDay(day) {
    if (this.identifyCurrentDay === true) {
      const date = moment().year(this.currentYear).dayOfYear(this.startDay + day);
      // console.log(moment().month());
      // console.log(this.currentMonth);
      return moment().month() === date.month() && moment().year() === date.year() && moment().date() === date.date();
    }
    return false;
  }
  checkDay(date) {
    let resp = [];
     Object.keys(this.schedule).map( month => {
        Object.keys(this.schedule[month]).map(day => {
          this.schedule[month][day].map(daySchedule => {
            if ((daySchedule.repeat_time === false || daySchedule.repeat_time === 'none') &&
              +day === +this.getDayNumber(date) &&
              (+month === +this.getMonthNumber(date) ||
                month === date.format('MMM Do YY')) && +daySchedule.year === date.year()) {
              resp.push(daySchedule);
            }
            // console.log(daySchedule);
            // console.log(date);
            if (daySchedule.repeat_time === 'week' &&
              daySchedule.dayName === date.format('dddd').substring(0, 3).toLowerCase()) {
              resp.push(daySchedule);
            }
            // switch (daySchedule.repeat_time) {
            //   case 'day':
            //     resp.push(daySchedule);
            //     break;
            //   case 'week':
            //     console.log(daySchedule);
            //     if (daySchedule.dayName === date.format('dddd').substring(0, 3).toLowerCase()) {
            //       resp.push(daySchedule);
            //     }
            //     break;
            //   case 'month':
            //     if (+day === +this.getDayNumber(date)) {
            //       resp.push(daySchedule);
            //     }
            //     break;
            //   case 'none':
            //     if (+day === +this.getDayNumber(date) &&
            //       (+month === +this.getMonthNumber(date) || month === date.format('MMM Do YY')) && +daySchedule.year === date.year()) {
            //       resp.push(daySchedule);
            //     }
            //     break;
            // }
          });
      });
    });
    return resp;
    // console.log(this.schedule);
    // console.log(moment().day(date.day).month(date.month));
    // return !!(this.schedule && date.month === this.currentMonth &&  this.schedule[date.day + 1] );
  }
  getDayNumber(day) {
    return moment(day).date();
  }
  getMonthNumber(day) {
    return moment(day).month() + 1;
  }
  getDayNumberByDayYear(day) {
    return moment().dayOfYear(this.startDay + day).date();
  }
  // flatten(arr) {
  //   return arr.reduce((flat, toFlatten) => {
  //     return flat.concat(Array.isArray(toFlatten) ? this.flatten(toFlatten) : toFlatten);
  //   }, []);
  // }
  clearCalendar(clearBorder = true) {
    // this.initSelected = null;
    // console.log('clear');
    const days = document.getElementsByClassName('days');
      new Array(days.length).fill(1).map((dayNumber, i) => {
        const items = days.item(i).getElementsByTagName('li');
        Object.keys(items).map((item, y) => {
          items[item].classList.remove('selectedCalendarItem');
          if ( typeof items[y] !== 'undefined') {
            items[item].classList.remove('selectedCalendarItem');
            if (clearBorder) {
              // items[item].classList.remove('active-border');
            }
          }
        });
      });
  }

  unsubscribe() {
    this.subscribes.map( subscr => {
      subscr.unsubscribe();
    });
  }
  detectStartDay(month = null, year = null) {
    let momentsDay = moment();
    if (month) {
      momentsDay.month(month - 1);
    }
    if (year) {
      momentsDay.year(year);
    }

    let firstMonthDay = momentsDay.startOf('month');
    const weekDayNumber = firstMonthDay.weekday() === 0 ? 7 : firstMonthDay.weekday();
    const numberInWeek = (0 - weekDayNumber) * -1;
    if (numberInWeek > 4) {
      this.numberOfDays = new Array(42);
    } else {
      this.numberOfDays = new Array(35);
    }
    this.startDay = firstMonthDay.dayOfYear() - numberInWeek;
  }
}
